import flatpickrTranslationAssets from './flatpickrTranslationAssets';


const flatpickrTranslation = angular.module('flatpickrTranslation', []);

flatpickrTranslation.factory('flatpickrTranslationLoader', function() {

    // return loaderFn
    return function(lang) {
        return flatpickrTranslationAssets(lang);
    };
});

export default flatpickrTranslation;



// WEBPACK FOOTER //
// ./src/app/flatpickrTranslation.js